import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  beforeLoad: ({ context }) => {
    const isAuthenticated = !!context.auth.authorization.token;
    if (isAuthenticated) {
      throw redirect({
        to: '/home',
      });
    }
    throw redirect({
      to: '/sign-in',
    });
  },
});
